import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../authContext';

const FormGuard = ({ children }) => {
  const { userLoggedIn } = useAuth();
  const formValues = JSON.parse(sessionStorage.getItem('formValues')) || {};
  
  const requiredFields = [
    'fecha', 'nombreAnimal', 'edad', 'edadUnidad', 'especie', 'sexo', 'tutor', 'tipo_estudio'
  ];

  const isValid = requiredFields.every(field => formValues[field] && formValues[field].toString().trim() !== '');

  if (!userLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  
  return isValid ? children : <Navigate to="/analizar" replace />;
};

export default FormGuard;
